import { IGetItemsResult } from '../ServerApi/types/IGetItemsResult';
import { IPagedItemsParams } from '../ServerApi/types/IPage';
import { IRequest } from '../ServerApi/types/IRequest';
import { ServerService } from '../services/ServerService';
import { IListFetcher } from './IListFetcher';
import { ListResult } from './ListResult';

export class ServerResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListFetcher<TResource> {

  constructor(private server: ServerService,
              private requestType: new (params: IPagedItemsParams) => IRequest<IPagedItemsParams, TRequestResult>,
              private resultMapper: (result: TRequestResult) => TResource[]) { }

  public fetchList(params: IPagedItemsParams): ng.IPromise<ListResult<TResource>> {
    return this.server
      .sendRequest(new this.requestType(params))
      .then((result: TRequestResult) => {
        const startIndex = params.page ? params.page.startIndex : 0;
        return new ListResult<TResource>(this.resultMapper(result), startIndex, result.totalCount);
      });
  }

}
